module.exports = __webpack_public_path__ + "static/media/Mars10.60abc7ea.jpg";